module.exports = __webpack_public_path__ + "img/video_comment.67017a4a.svg";